import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const SOTELSApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "SOTELS" */ "./SOTELSApp");
    return { default: namedExport.SOTELSApp };
});

export const SOTELS: TeamAppConfig = {
    title: "EUII/EUPI Leak Investigation Platform",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "EUII/EUPI Leak Investigation Platform",
    team: "PrivacyArgusSuite",
    publicId: "PrivacyArgusSuite\\Triage",
    owner: "privacyargus@microsoft.com",
    role: "*",
    tags: ["SOTELS", "ELIP", "PrivacyArgusSuite", "PrivacyGuard", "PrivacyTrout"],
    app: SOTELSApp,
    path: "/SOTELS/ELIPApp",
    torusRequired: false
};
